export enum Visibility {
	Private = 'private',
	Immediate = 'immediate',
}

export enum FeedbackState {
	Request = 'request',
	Draft = 'draft',
	DraftRequest = 'draft_request',
	Published = 'published',
}

// TODO: Cleanup unused fields
export interface FeedbackApiData {
	id: string;
	company_id: string;
	created_at: string;
	completed_at: string;
	expires_at: string;
	messages: MessageRequestApiData[];
	draft_messages: MessageRequestApiData[];
	receiver: UserData;
	receiver_id: string;
	reference_id: string;
	reference_type: string;
	seen_by_user_ids: string[];
	updated_at: string;
	template: { [key: string]: string };

	// New Feedback fields
	giver: UserData;
	giver_id: string;
	llm_feedback_summary: string;
	llm_run_id: string;
	published_at: string;
	request: FeedbackRequestApiData | null;
	shared_with_user_ids: string[];
	state: FeedbackState;
}

export interface FeedbackRequestApiData {
	id: string;
	expires_at: string;
	requested_at: string;
	text: string;
}

export interface MessageRequestApiData {
	id: string;
	created_at: string;
	evaluation_id?: string;
	feedback_id: string;
	text: string;
	updated_at: string;
	user: UserData;
	user_id: string;
}

interface UserData {
	id: string;
	created_at: string;
	display_name: string;
	profile_pic: string;
	username: string;
	updated_at: string;
}
